import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CartDetailsComponent } from './cart-details/cart-details.component';
import { BillingComponent } from './billing/billing.component';
import { OrderPreviewComponent } from './order-preview/order-preview.component';
import { PaymentComponent } from './payment/payment.component';
import { SuccessorderComponent } from './successorder/successorder.component';
import {AuthGuard} from './../../shared/guard/auth.guard';

const routes: Routes = [
  {
    path:"cart",
    component:CartDetailsComponent
  },
  {
    path:"billing",
    canActivate:[AuthGuard],
    component:BillingComponent
  },
  {
    path:"preview",
    canActivate:[AuthGuard],
    component:OrderPreviewComponent
  },
  {
    path:"payment",
    canActivate:[AuthGuard],
    component:PaymentComponent
  },
  {
    path:"success",
    canActivate:[AuthGuard],
    component:SuccessorderComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CartRoutingModule { }
